import { MILESTONE } from "../../shared/stars";

/**
 * Seven segments toward the next 7-day badge. A streak of exactly 7, 14… shows all seven lit,
 * so the badge moment is a full strip rather than an empty one.
 */
export function StreakStrip({ streak }: { streak: number }) {
  const lit = streak === 0 ? 0 : ((streak - 1) % MILESTONE) + 1;
  return (
    <div className="streak-strip" role="img" aria-label={`${lit} of ${MILESTONE} toward the next badge`}>
      {Array.from({ length: MILESTONE }, (_, i) => (
        <span key={i} className="streak-strip__segment" data-lit={i < lit || undefined} />
      ))}
    </div>
  );
}
